import {useCallback, useState} from 'react';

export interface IUseCreateGate {
    open: () => void,
    close: () => void,
    isCreateOpen: boolean,
    isExceededOpen: boolean,
}

type GateState = 'create' | 'exceeded' | null;

export const useCreateGate = (canCreate: boolean): IUseCreateGate => {
    const [state, setState] = useState<GateState>(null);

    const open = useCallback(() => setState(canCreate ? 'create' : 'exceeded'), [canCreate]);
    const close = useCallback(() => setState(null), []);

    return {
        open,
        close,
        isCreateOpen: state === 'create',
        isExceededOpen: state === 'exceeded',
    };
};

export default useCreateGate;
